import 'vue-googlemaps/dist/vue-googlemaps.css'
import VueGoogleMaps from 'vue-googlemaps'
import Vue from 'vue'

Vue.use(VueGoogleMaps, {
  load: {
    // Google API key
    apiKey: 'AIzaSyAig8_zH56JGcO2b5iXS8wd-NjQSsEPjOo',
    // Enable more Google Maps libraries here
    libraries: [ 'places' ],
    // Use new renderer
    useBetaRenderer: false,
  },
})
